<app-generic-container>
  <!-- Usamos el panel genérico -->
  <app-generic-panel [title]="panelTitle" [description]="panelDescription" [awesomeIcon]="panelIcon">

    <div class="row" style="margin-bottom: 20px;">
      <div class="col-12">
        <div class="row">
          <div class="col-md col-lg col-xl">
            <app-company-selector dataSize="7" placeHolder="Empresas" [(ngModel)]="selectedCompany"
              [required]="true" [onlyConfigured] = "true"></app-company-selector>
          </div>
          <div class="col-md col-lg col-xl">
            <app-year-selector dataSize="7" placeHolder="Ejercicio" [(selectedValue)]="selectedYear" [required]="true">
            </app-year-selector>
          </div>
          <!-- Botón de búsqueda -->
          <div class="col-md-auto col-lg-auto col-xl-auto">
            <button class="btn btn-fill btn-primary float-right" [disabled]="!selectedYear || !selectedCompany"
              (click)="onSearch()">Buscar</button>
          </div>
        </div>
      </div>
    </div>

    <mat-tab-group (selectedTabChange)="onSelectedTabChange()">
      <mat-tab label="Personas">
        <dx-data-grid #gridPersonas [dataSource]="holidaysExtraPays" [allowColumnResizing]="true"
          [columnResizingMode]="'widget'" (onEditorPreparing)="onEditorPreparing($event)">
          <!-- Definición de las columnas -->
          <dxi-column caption="Empresa" alignment="center">
            <dxi-column dataField="CodigoEmpresa" caption="Código" alignment="center"></dxi-column>
            <dxi-column dataField="DescripcionEmpresa" caption="Empresa"> </dxi-column>
          </dxi-column>
          <dxi-column caption="Centro" alignment="center">
            <dxi-column dataField="CodigoCentro" caption="Código" alignment="center"> </dxi-column>
            <dxi-column dataField="DescripcionCentro" caption="Centro"> </dxi-column>
          </dxi-column>
          <dxi-column caption="Imputación" alignment="center">
            <dxi-column dataField="CodigoImputacion" caption="Código" alignment="center"> </dxi-column>
            <dxi-column dataField="DescripcionImputacion" caption="Imputacion"> </dxi-column>
          </dxi-column>
          <dxi-column caption="Trabajador" alignment="center">
            <dxi-column dataField="CodigoTrabajador" caption="Código" alignment="center"> </dxi-column>
            <dxi-column dataField="NombreTrabajador" caption="Trabajador"> </dxi-column>
          </dxi-column>
          <dxi-column caption="Datos del trabajador" alignment="center">
            <dxi-column dataField="Ejercicio" caption="Ejercicio" alignment="center"> </dxi-column>
            <dxi-column dataField="DiasITAbsentismo" caption="Días IT" alignment="center"> </dxi-column>
            <dxi-column dataField="ImporteBolsa" caption="Importe bolsa">
              <dxo-format type="currency" [precision]="2"></dxo-format>
            </dxi-column>
            <dxi-column dataField="ImporteProporcional" caption="Importe proporcional">
              <dxo-format type="currency" [precision]="2"></dxo-format>
            </dxi-column>
            <dxi-column dataField="ImporteCobrado" caption="Cobrado">
              <dxo-format type="currency" [precision]="2"></dxo-format>
            </dxi-column>
            <dxi-column dataField="Importe" caption="Total">
              <dxo-format type="currency" [precision]="2"></dxo-format>
            </dxi-column>
          </dxi-column>

          <!-- Templates -->
          <dxi-column caption="" [fixed]="true" [fixedPosition]="'right'">
            <dxi-column dataField="Id" caption=" " [allowFiltering]="false" [allowSorting]="false" alignment="center"
              [allowExporting]="false" cellTemplate="buttonCRUDTemplate"></dxi-column>
          </dxi-column>
          <ng-container *dxTemplate="let data of 'buttonCRUDTemplate'">
            <button rel="tooltip" type="button" class="btn btn-success btn-action" (click)="onClickEdit(data.row.data)">
              <i class="material-icons">edit</i>
            </button>
          </ng-container>

          <dxo-export [enabled]="true"></dxo-export>


        </dx-data-grid>
      </mat-tab>
      <mat-tab label="Periodos">
        <dx-data-grid #gridPeriodos [dataSource]="periodos" [allowColumnResizing]="true" [columnResizingMode]="'widget'"
          (onEditorPreparing)="onEditorPreparing($event)">

          <dxi-column caption="Empresa" alignment="center">
            <dxi-column dataField="CodigoEmpresa" caption="Código"></dxi-column>
            <dxi-column dataField="DescripcionEmpresa" caption="Empresa"> </dxi-column>
          </dxi-column>
          <dxi-column caption="Centro" alignment="center">
            <dxi-column dataField="CodigoCentro" caption="Código"> </dxi-column>
            <dxi-column dataField="DescripcionCentro" caption="Centro"> </dxi-column>
          </dxi-column>
          <dxi-column caption="Imputación" alignment="center">
            <dxi-column dataField="CodigoImputacion" caption="Código"> </dxi-column>
            <dxi-column dataField="DescripcionImputacion" caption="Imputacion"> </dxi-column>
          </dxi-column>
          <dxi-column caption="Trabajador" alignment="center">
            <dxi-column dataField="CodigoTrabajador" caption="Código"> </dxi-column>
            <dxi-column dataField="NombreTrabajador" caption="Trabajador"> </dxi-column>
          </dxi-column>
          <dxi-column caption="Solicitudes de bolsa" alignment="center">
            <dxi-column dataField="Ejercicio" caption="Ejercicio"> </dxi-column>

            <dxi-column dataField="FechaSolicitud" caption="Fecha" dataType="date" alignment="right"></dxi-column>
            <dxi-column dataField="Dias" caption="Días"> </dxi-column>
            <dxi-column dataField="Importe" caption="Importe">
              <dxo-format type="currency" [precision]="2"></dxo-format>
            </dxi-column>
            <dxi-column dataField="Observaciones" caption="Observaciones">
            </dxi-column>
          </dxi-column>

          <dxo-grouping #expand [autoExpandAll]="true"></dxo-grouping>
          <!-- <dxo-master-detail [enabled]="true" template="detail"></dxo-master-detail>
        <div *dxTemplate="let holidayExtraPay of 'detail'">
            <div class="master-detail-caption">Solicitudes</div>
            <app-grid-solicitudes-bolsa-vacaciones [holidayExtraPay]="holidayExtraPay.data"></app-grid-solicitudes-bolsa-vacaciones>
        </div> -->

          <dxo-export [enabled]="true"></dxo-export>



        </dx-data-grid>
      </mat-tab>

    </mat-tab-group>







  </app-generic-panel>

  <br>

  <!-- <app-A3LEmployees-List (onCreateA3LaboralUser)="onCreateA3LaboralUser()">
  </app-A3LEmployees-List> -->

</app-generic-container>
